import React from 'react'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'

export interface StatusChipProps {
  /** Status da partida */
  status: 'AGENDADA' | 'EM_ANDAMENTO' | 'FINALIZADA' | 'CANCELADA'
}

const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const color = status === 'AGENDADA' ? '#f0ad4e' : '#5cb85c'
  const label = status
  const bg = status === 'AGENDADA' ? 'rgba(240,173,78,0.2)' : 'rgba(92,184,92,0.2)'

  return (
    <Chip
      label={label}
      className='ps-2'
      sx={{
        backgroundColor: bg,
        color: '#000',
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 0, marginRight: 0.5 }
      }}
      icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color }} />}
      size="small"
    />
  )
}

export default StatusChip
